import React from 'react';
import Side from 'components/side/Side'
import Header from 'components/Header'
import {getPath} from 'local-util'
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Footer from "material-admin/components/Footer/Footer";
import Sidebar from "material-admin/components/Sidebar/Sidebar";

import appStyle from "assets/material-admin/assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";

import image from "material-admin/assets/img/sidebar-2.jpg";
import logo from "material-admin/assets/img/logo-white.svg";
import cx from "classnames";
import PropTypes from "prop-types";

const recursivePath = (item, paths, pathObj) => {
  let children = item.bigGoals || item.stepGoals || item.actionPlans || item.strategies

  let type;
  if (item.strategies) {
    type = "Company"
  } else if (item.bigGoals) {
    type = "Strategy"
  } else if (item.stepGoals) {
    type = "Big Goal"
  } else if (item.actionPlans) {
    type = "Step Goal"
  } else {
    type = "Action Plan"
  }

  const newPath = paths.concat([{name: item.name, type, index: item.index, id: item.id}])

  pathObj[item.id] = newPath

  if (children) {
    children.forEach((c) => {
      recursivePath(c, newPath, pathObj)
    })
  }
}

class Dashboard extends React.Component {
  constructor(props) {
    super(props)

    props.routes[0].helper.handleDrawerToggle = this.handleDrawerToggle
  }
  state = {
    mobileOpen: false,
    miniActive: false
  }
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      this.ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      this.ps.destroy();
    }
  }
  componentDidUpdate(e) {
    // Location updates, should probably be handled in base component
    // if (e.history.location.pathname !== e.location.pathname) {
    //   this.refs.mainPanel.scrollTop = 0;
    //   if(this.state.mobileOpen){
    //     this.setState({mobileOpen: false})
    //   }
    // }
  }
  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }
  activeCompanyFromCompanies() {
    const companies = (this.props.companies && this.props.companies.companies) || []
    const activeCompanyId = getPath(this, ['props', 'profile', 'activeCompanyId']) || window.localStorage.getItem('activeCompanyId')

    if (activeCompanyId && companies.length > 1) {
      return companies.find((c) => {
        return c.id == activeCompanyId
      })
    } else if ((!activeCompanyId && companies.length > 1) || (companies.length == 1)) {
      return companies[0]
    }
    else {
      return null
    }
  }
  activeCompany() {
    return this.props.activeCompany
  }
  getCompany() {
    return this.activeCompany() || this.activeCompanyFromCompanies()
  }
  planFromProps(company) {
    const activePropId = getPath(this, ['props', 'profile', 'activePathId'])

    if (company && company.strategies && activePropId) {
      let pathObjs = {}
      let path = recursivePath(company, [], pathObjs)

      return pathObjs[activePropId]
    } else {
      return null
    }
  }
  getPath(company) {
    if (!company) {
      return null
    } else {
      const fromProps = this.planFromProps(company)

      if (fromProps) {
        return fromProps
      }

      const planType = this.props.route.planType

      if (planType) {
        const p = this.props[planType]

        return p && p.path && JSON.parse(p.path)
      } else {
        return []
      }
    }
  }
  render() {
    const { classes, ...rest } = this.props;
    const mainPanel =
            classes.mainPanel +
            " " +
            cx({
              [classes.mainPanelSidebarMini]: this.state.miniActive,
              [classes.mainPanelWithPerfectScrollbar]:
              navigator.platform.indexOf("Win") > -1
            });

    const company = this.getCompany()
    const path = this.getPath(company)

    return (
      <div className={classes.wrapper}>

        <Side
           logoText={"Aardvark"}
           sideCompany={company}
           sidePath={path}
           logo={logo}
           image={image}
           companyHeader={this.props.children.props['side']}
           handleDrawerToggle={this.handleDrawerToggle}
           open={this.state.mobileOpen}
           miniActive={this.state.miniActive}
           color="blue"
           bgColor="black"
           {...rest}
           />


        <div className={mainPanel} ref="mainPanel">
          {this.props.children.props['header']}
          {this.props.children.props['main']}
        </div>

      </div>
    )
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(appStyle)(Dashboard);
